import React from 'react';

import { LoadingType } from 'actions';
import Loader from 'components/Loader';
import { ContractorPortalStep } from 'enums/ContractorPortalStep';
import { useAppSelector } from 'hooks/useAppSelector';
import NotFoundContact from 'pages/NotFound/NotFoundContact';

import AlreadySetUpWithCSM from './steps/AlreadySetUpWithCSM';
import AlreadySetUpWithoutCSM from './steps/AlreadySetUpWithoutCSM';
import Congratulations from './steps/Congratulations';
import ContractorApplication from './steps/ContractorApplication';

const getPageByStep = (step: ContractorPortalStep | null) => {
  switch (step) {
    case ContractorPortalStep.ContractorApplication:
      return <ContractorApplication />;
    case ContractorPortalStep.Congratulations:
      return <Congratulations />;
    case ContractorPortalStep.NotFoundContact:
      return <NotFoundContact />;
    case ContractorPortalStep.AlreadySetUpWithCSM:
      return <AlreadySetUpWithCSM />;
    case ContractorPortalStep.AlreadySetUpWithoutCSM:
      return <AlreadySetUpWithoutCSM />;
    default:
      return <ContractorApplication />;
  }
};

const ContractorPortal = () => {
  const { currentContractorPortalStep } = useAppSelector((state) => state.stages);
  const loading = useAppSelector((state) => state.loading[LoadingType.ApplicationUpdate]);

  return loading ? <Loader /> : getPageByStep(currentContractorPortalStep);
};

export default ContractorPortal;
